/**
 * Admin client configuration.
 *
 * Resolution order (highest priority first):
 *   1. import.meta.env.VITE_API_BASE_URL   (build-time; injected by CI per environment)
 *   2. localhost:8787                      (only when import.meta.env.DEV === true)
 *   3. throw                               (no silent fallback in production/staging)
 *
 * Rationale: the previous silent fallback to '/api' caused a production
 * outage where admin requests landed on the Pages origin (which has no
 * /api/v1/* Worker route) instead of the backend Worker. The Admin bundle
 * now requires VITE_API_BASE_URL at build time for any non-dev build;
 * .github/workflows/admin.yml injects the matching URL per job.
 *
 * The <meta name="api-base-url"> escape hatch is intentionally NOT honored
 * here. Admin's single source of truth for the API base URL is
 * VITE_API_BASE_URL at build time.
 */

function resolveAdminApiBaseUrl(): string {
  const fromVite = import.meta.env.VITE_API_BASE_URL;
  if (typeof fromVite === 'string' && fromVite.length > 0) {
    return fromVite;
  }

  if (import.meta.env.DEV) {
    return 'http://localhost:8787';
  }

  throw new Error(
    '[admin] VITE_API_BASE_URL is not configured. ' +
      'Set it in the GitHub Actions workflow (see .github/workflows/admin.yml) ' +
      'or as a build-time env var for any non-dev build. ' +
      'No silent fallback is permitted in production or staging.',
  );
}

export const config = {
  baseUrl: resolveAdminApiBaseUrl(),
  apiVersion: 'v1',
  get apiBase() {
    return `${this.baseUrl}/api/${this.apiVersion}`;
  },
} as const;
